/* CONTRABAND commerce: case-file quick view (real variants) + STASH drawer (real cart) */
(function(){
  'use strict';
  var FIT = {
    'manifest-tee': 'RUNS TRUE TO SIZE',
    'off-the-record-shorts': 'RELAXED FIT — TRUE TO SIZE',
    'stash-pocket-hoodie': 'OVERSIZED — SIZE DOWN FOR A REGULAR FIT',
    'long-haul-long-sleeve': 'HIGH STRETCH — TRUE TO SIZE'
  };
  function money(cents){ return '$' + (cents/100).toFixed(2); }
  function el(html){
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstChild;
  }
  var toastEl = null, toastTimer = null;
  function toast(msg){
    if (!toastEl){ toastEl = el('<div class="cbx-toast"></div>'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove('show'); }, 2800);
  }

  /* ---------- header logo: slashed O ---------- */
  var logoLink = document.querySelector('header-component a[href="/"]');
  if (logoLink && /contraband/i.test(logoLink.textContent || '')){
    logoLink.classList.add('cbx-logo');
    logoLink.innerHTML = 'CØNTRA<span>BAND</span>';
  }

  /* ---------- header STASH button ---------- */
  var stashBtn = el('<button type="button" class="cbx-stashbtn" aria-label="Open cart">STASH <span class="cbx-count">0</span></button>');
  var cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]')
    || document.querySelector('header-component button[aria-controls="cart-drawer"]')
    || document.querySelector('header-component a[href$="/cart"]');
  if (cartTrigger && cartTrigger.parentNode){
    cartTrigger.style.display = 'none';
    cartTrigger.parentNode.insertBefore(stashBtn, cartTrigger);
  } else {
    stashBtn.classList.add('floating');
    document.body.appendChild(stashBtn);
  }
  function setCount(n){
    var c = stashBtn.querySelector('.cbx-count');
    if (c) c.textContent = n;
  }

  /* ---------- STASH drawer ---------- */
  var SHIP_FREE = 7500;
  var scrim = el('<div class="cbx-scrim"></div>');
  var drawer = el(
    '<aside class="cbx-stash" aria-label="Shopping cart">' +
      '<div class="cbx-shead"><h3>THE STASH</h3><button type="button" data-close aria-label="Close">✕</button></div>' +
      '<div class="cbx-shipbar"><div class="cbx-shipmsg" data-shipmsg></div><div class="cbx-track"><div class="cbx-fill" data-fill></div></div></div>' +
      '<div class="cbx-sitems" data-items></div>' +
      '<div class="cbx-sfoot">' +
        '<div class="cbx-totals grand"><span>SUBTOTAL</span><span data-total>$0.00</span></div>' +
        '<button type="button" class="cbx-checkout" data-checkout>CHECKOUT →</button>' +
        '<small>SHIPPING CALCULATED AT CHECKOUT · FREE US SHIPPING OVER $75</small>' +
      '</div>' +
    '</aside>');
  document.body.appendChild(scrim);
  document.body.appendChild(drawer);
  function openStash(){ drawer.classList.add('open'); scrim.classList.add('open'); }
  function closeStash(){ drawer.classList.remove('open'); scrim.classList.remove('open'); }
  stashBtn.addEventListener('click', function(){ refreshCart(); openStash(); });
  drawer.querySelector('[data-close]').addEventListener('click', closeStash);
  scrim.addEventListener('click', closeStash);
  drawer.querySelector('[data-checkout]').addEventListener('click', function(){ window.location.href = '/checkout'; });

  function renderCart(cart){
    setCount(cart.item_count);
    var box = drawer.querySelector('[data-items]'), html = '';
    cart.items.forEach(function(it, i){
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/i, '_120x$1$2') : '';
      html += '<div class="cbx-sitem">' +
        '<div class="cbx-sthumb">' + (img ? '<img src="'+img+'" alt="">' : '') + '</div>' +
        '<div class="cbx-smeta"><b>' + it.product_title + '</b><span>' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.toUpperCase() + ' · ' : '') + money(it.final_price) + '</span></div>' +
        '<div class="cbx-sqty"><button data-line="'+(i+1)+'" data-d="-1" aria-label="Less">−</button><b>' + it.quantity + '</b><button data-line="'+(i+1)+'" data-d="1" aria-label="More">+</button></div>' +
        '<div class="cbx-sprice">' + money(it.final_line_price) + '</div></div>';
    });
    box.innerHTML = html || '<div class="cbx-sempty">STASH IS EMPTY.<br>SUSPICIOUSLY CLEAN.</div>';
    drawer.querySelector('[data-total]').textContent = money(cart.total_price);
    var pct = Math.min(100, Math.round(cart.total_price / SHIP_FREE * 100));
    drawer.querySelector('[data-fill]').style.width = pct + '%';
    drawer.querySelector('[data-shipmsg]').innerHTML = cart.total_price >= SHIP_FREE
      ? '<b>FREE SHIPPING UNLOCKED ✓</b>'
      : 'ADD <b>' + money(SHIP_FREE - cart.total_price) + '</b> MORE FOR FREE SHIPPING';
  }
  function refreshCart(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ renderCart(c); return c; });
  }
  drawer.querySelector('[data-items]').addEventListener('click', function(e){
    var b = e.target.closest('button[data-line]');
    if (!b) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
      var line = +b.getAttribute('data-line');
      var q = c.items[line-1].quantity + (+b.getAttribute('data-d'));
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, q) })
      });
    }).then(function(r){ return r.json(); }).then(renderCart);
  });
  refreshCart();

  /* ---------- case-file quick view ---------- */
  var overlay = el(
    '<div class="cbx-overlay" role="dialog" aria-modal="true" aria-label="Product case file">' +
      '<div class="cbx-modal">' +
        '<div class="cbx-mhead"><span>CASE FILE 0024-77</span><span class="cbx-mex" data-ex></span><button type="button" class="cbx-mclose" data-close aria-label="Close">✕</button></div>' +
        '<div class="cbx-mbody">' +
          '<div class="cbx-mleft">' +
            '<div class="cbx-mart"><img data-img src="" alt=""><div class="cbx-mstamp" data-stamp>INTERCEPTED</div></div>' +
            '<div class="cbx-mthumbs" data-thumbs></div>' +
          '</div>' +
          '<div class="cbx-minfo">' +
            '<div class="cbx-mcat" data-cat></div>' +
            '<h3 class="cbx-mname" data-name></h3>' +
            '<div class="cbx-mprice" data-price></div>' +
            '<p class="cbx-mdesc" data-desc></p>' +
            '<div class="cbx-mfit" data-fit></div>' +
            '<div data-opts></div>' +
            '<div class="cbx-mactions">' +
              '<div class="cbx-qtyrow"><span class="cbx-qtylbl">QTY</span><div class="cbx-qtybox"><button type="button" data-qminus aria-label="Less">−</button><b data-qval>1</b><button type="button" data-qplus aria-label="More">+</button></div></div>' +
              '<button type="button" class="cbx-addbtn" data-add>ADD TO STASH</button>' +
            '</div>' +
            '<div class="cbx-wl" data-wl hidden>' +
              '<div class="cbx-wlnote">SOLD OUT — INTERCEPTED. DROP YOUR EMAIL AND WE\'LL TIP YOU OFF WHEN IT\'S BACK.</div>' +
              '<div class="cbx-wlrow"><input type="email" data-wl-email placeholder="your@email.com" aria-label="Waitlist email"><button type="button" data-wl-join>TIP ME OFF</button></div>' +
            '</div>' +
            '<div class="cbx-mlink" data-link></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>');
  document.body.appendChild(overlay);
  overlay.addEventListener('click', function(e){ if (e.target === overlay) closeCase(); });
  overlay.querySelector('[data-close]').addEventListener('click', closeCase);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){ closeCase(); closeStash(); }
  });
  function closeCase(){ overlay.classList.remove('open'); }

  var prod = null, sel = {}, qty = 1;
  function q(s){ return overlay.querySelector(s); }
  function currentVariant(){
    if (!prod) return null;
    for (var i = 0; i < prod.variants.length; i++){
      var v = prod.variants[i], ok = true;
      for (var j = 0; j < prod.options.length; j++){
        var name = prod.options[j].name || prod.options[j];
        if (v.options[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function optName(o){ return (typeof o === 'string') ? o : o.name; }
  function optValues(o, idx){
    if (o && o.values) return o.values;
    var seen = {}, out = [];
    prod.variants.forEach(function(v){ if (!seen[v.options[idx]]){ seen[v.options[idx]] = 1; out.push(v.options[idx]); } });
    return out;
  }
  function renderOpts(){
    var box = q('[data-opts]'), html = '';
    prod.options.forEach(function(o, idx){
      var name = optName(o);
      if (name === 'Title' && prod.options.length === 1) return;
      html += '<div class="cbx-optlabel">' + name.toUpperCase() + '</div><div class="cbx-opts" data-optidx="' + idx + '">';
      optValues(o, idx).forEach(function(val){
        var avail = prod.variants.some(function(v){ return v.options[idx] === val && v.available; });
        html += '<button type="button" class="cbx-opt' + (sel[idx] === val ? ' on' : '') + (avail ? '' : ' off') + '" data-val="' + val.replace(/"/g,'&quot;') + '">' + val + '</button>';
      });
      html += '</div>';
    });
    box.innerHTML = html;
  }
  function syncVariant(){
    var v = currentVariant();
    var addBtn = q('[data-add]');
    if (v){
      q('[data-price]').textContent = money(v.price);
      if (v.featured_image && v.featured_image.src) setImg(v.featured_image.src);
      if (v.available){ addBtn.disabled = false; addBtn.textContent = 'ADD TO STASH'; }
      else { addBtn.disabled = true; addBtn.textContent = 'SOLD OUT — INTERCEPTED'; }
    } else {
      addBtn.disabled = true; addBtn.textContent = 'UNAVAILABLE';
    }
  }
  function setImg(src){
    q('[data-img]').src = sized(src, 600);
    Array.prototype.forEach.call(overlay.querySelectorAll('.cbx-mthumb'), function(t){
      t.classList.toggle('on', t.getAttribute('data-src') === src);
    });
  }
  function sized(src, w){
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function openCaseFile(handle){
    fetch('/products/' + handle + '.js').then(function(r){
      if (!r.ok) throw new Error('nf');
      return r.json();
    }).then(function(p){
      prod = p; sel = {}; qty = 1;
      q('[data-qval]').textContent = '1';
      var anyAvail = p.variants.some(function(v){ return v.available; });
      var pre = null;
      for (var i = 0; i < p.variants.length; i++){ if (p.variants[i].available){ pre = p.variants[i]; break; } }
      pre = pre || p.variants[0];
      p.options.forEach(function(o, idx){ sel[idx] = pre.options[idx]; });
      q('[data-ex]').textContent = anyAvail ? 'STATUS: IN CIRCULATION' : 'STATUS: INTERCEPTED';
      q('[data-stamp]').style.display = anyAvail ? 'none' : 'block';
      q('[data-wl]').hidden = anyAvail;
      q('[data-wl-email]').value = '';
      q('[data-name]').textContent = p.title;
      q('[data-cat]').textContent = (p.type || 'CONTRABAND').toUpperCase() + ' · CASE ITEM';
      var d = document.createElement('div'); d.innerHTML = p.description || '';
      var txt = (d.textContent || '').replace(/\s+/g, ' ').trim();
      q('[data-desc]').textContent = txt.length > 180 ? txt.slice(0, 177) + '…' : txt;
      q('[data-fit]').textContent = 'FIT NOTE: ' + (FIT[handle] || 'TRUE TO SIZE');
      var th = '', imgs = (p.images || []).slice(0, 4);
      imgs.forEach(function(s, i){
        th += '<button type="button" class="cbx-mthumb' + (i === 0 ? ' on' : '') + '" data-src="' + s + '" aria-label="Photo ' + (i+1) + '"><img src="' + sized(s, 120) + '" alt=""></button>';
      });
      q('[data-thumbs]').innerHTML = th;
      if (imgs.length) q('[data-img]').src = sized(imgs[0], 600);
      q('[data-link]').innerHTML = 'FULL LISTING: <a href="/products/' + handle + '" data-cbx-real>OPEN PRODUCT PAGE →</a>';
      renderOpts();
      syncVariant();
      overlay.classList.add('open');
    }).catch(function(){
      window.location.href = '/products/' + handle;
    });
  }
  q('[data-thumbs]').addEventListener('click', function(e){
    var t = e.target.closest('.cbx-mthumb');
    if (t) setImg(t.getAttribute('data-src'));
  });
  q('[data-opts]').addEventListener('click', function(e){
    var b = e.target.closest('.cbx-opt');
    if (!b) return;
    var wrap = e.target.closest('[data-optidx]');
    sel[+wrap.getAttribute('data-optidx')] = b.getAttribute('data-val');
    renderOpts();
    syncVariant();
  });
  q('[data-wl-join]').addEventListener('click', function(){
    var em = q('[data-wl-email]').value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)){ toast('ENTER A REAL EMAIL — WE CAN\'T TIP OFF A GHOST'); return; }
    var handle = prod && prod.handle ? prod.handle : 'unknown';
    var body = 'form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=' + encodeURIComponent(em)
             + '&contact%5Btags%5D=' + encodeURIComponent('waitlist,waitlist-' + handle);
    fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body })
      .then(function(){ closeCase(); toast('ON THE LIST — YOU\'LL KNOW WHEN IT RESURFACES'); })
      .catch(function(){ toast('COULD NOT SIGN YOU UP — USE THE SIGNUP ON THE HOME PAGE'); });
  });
  q('[data-qminus]').addEventListener('click', function(){ if (qty > 1){ qty--; q('[data-qval]').textContent = qty; } });
  q('[data-qplus]').addEventListener('click', function(){ if (qty < 9){ qty++; q('[data-qval]').textContent = qty; } });
  q('[data-add]').addEventListener('click', function(){
    var v = currentVariant();
    if (!v || !v.available) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: qty })
    }).then(function(r){
      if (!r.ok) throw new Error('add');
      return refreshCart();
    }).then(function(){
      closeCase();
      toast('ADDED ×' + qty + ' — ' + prod.title.toUpperCase());
      openStash();
    }).catch(function(){ toast('COULD NOT ADD — TRY THE FULL LISTING'); });
  });

  /* ---------- intercept product clicks ---------- */
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href*="/products/"]');
    if (!a || a.hasAttribute('data-cbx-real')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9\-]+)/i);
    if (!m) return;
    if (location.pathname === '/products/' + m[1]) return; /* already on that product's page */
    e.preventDefault();
    e.stopPropagation();
    openCaseFile(m[1]);
  }, true);

  /* ---------- product page case-file treatment ---------- */
  var pm = location.pathname.match(/^\/products\/([a-z0-9\-]+)/i);
  if (pm){
    var ph1 = document.querySelector('.product-information h1');
    if (ph1){
      ph1.insertAdjacentHTML('beforebegin', '<div class="cbx-casebar">CASE FILE 0024-77 · CASE ITEM · ON RECORD</div>');
      var fit = FIT[pm[1]];
      if (fit) ph1.insertAdjacentHTML('afterend', '<div class="cbx-mfit cbx-fit-pp">FIT NOTE: ' + fit + '</div>');
    }
  }

  window.CBX = window.CBX || {};
  window.CBX.openCaseFile = openCaseFile;
  window.CBX.openStash = openStash;
})();
